/**
 * Format relative time in Spanish — short form (8m, 2h, 3d).
 * Original utility, not copied from any specific library.
 */
export function formatRelative(iso: string): string {
  try {
    const date = new Date(iso);
    const now = Date.now();
    const diff = Math.max(0, now - date.getTime());
    const sec = Math.floor(diff / 1000);
    if (sec < 60) return `${sec}s`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min}m`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h`;
    const d = Math.floor(hr / 24);
    if (d < 7) return `${d}d`;
    const w = Math.floor(d / 7);
    if (w < 4) return `${w}sem`;
    return date.toLocaleDateString('es', { day: '2-digit', month: '2-digit' });
  } catch {
    return '';
  }
}
